import { Folder as GraphqlFolder } from '../generated/types';
import { FolderListItem as FolderViewModel } from '../../viewModels/Folder';

export const mapToFolderViewModel = (source: GraphqlFolder, level: number, parentFolderId?: string): FolderViewModel =>
    ({
        parentFolderId,
        id: source.id,
        name: source.name,
        isExpanded: false,
        level,
        isTraversable: !!source.isTraversable,
    });

export const mapToFolderListViewModel = (source: Array<GraphqlFolder>, level: number, parentFolderId?: string): Array<FolderViewModel> => {
    return source.map((item) => mapToFolderViewModel(item, level, parentFolderId));
};
